export default import.meta.ROLLDOWN_FILE_URL_tIDUn2rChPOYQ1wn0fDMzw